export default "__VITE_ASSET__Jr98b0CQ__"